import React, { useEffect, useRef, useState } from "react";
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
} from "../../components";
import {
  Card,
  CardBody,
  Input,
  Select,
  SelectItem,
  Checkbox,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
  Button,
  Autocomplete, AutocompleteItem,
  ModalFooter,
  Textarea,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
} from "@heroui/react";
import { apiRoute, ENUM_ENTRY_TYPE, ENUM_INPUT_TYPE, ENUM_TRANSACTION_TYPE, funValidateNoInput, linksUrl, URIEncrypt } from "../../constants/enum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightLong,
  faCancel,
  faChain,
  faCheck,
  faFile,
  faSave,
  faWarning,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import BillsDetail from "./BillsDetail";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { useDispatch, useSelector } from "react-redux";
import { useLoaderData, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { isMobile } from 'react-device-detect';
import { resetDetailParams } from "../../state/receiveEntrySlice";
import { scrollInput, stickyBottomClass, stickyParentClass } from "../../Utility/utility";
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography, } from "@mui/material"

const CreateTransactionEntry = () => {
  const location = useLocation()
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const navigate = useNavigate();
  const { compCode, isMultipleCompany, startDate, endDate } = useSelector((state) => state.company);
  const { user } = useSelector((state) => state.auth);
  const { detailParams, isNewEntry } = useSelector((state) => state.receiveEntry);
  const { etype } = useParams()
  const [open, setOpen] = useState(false);
  const [selVouType, setSelVouType] = useState("R")
  const [entryLabel, setEntryLabel] = useState("Receive")
  const [isAmountFromBill, setIsAmountFromBill] = useState(false);
  const dispatch = useDispatch();
  const [submitBtnId, setSubmitBtnId] = useState("")
  const submitLockRef = useRef(false)
  const minAllowedDate = dayjs(startDate)
  const maxAllowedDate = dayjs(endDate)
  const formField = {
    transId: "transId",
    voucherNo: "voucherNo",
    transDate: "transDate",
    chqRecDate: "chqRecDate",
    partyName: "partyName",
    partyBank: "partyBank",
    partyId: "partyId",
    locationId: "locationId",
    bookName: "bookName",
    bookId: "bookId",
    docType: "docType",
    chqNo: "chqNo",
    convRate: "convRate",
    chqAmount: "chqAmount",
    chqAmountD: "chqAmountD",
    addAcName: "addAcName",
    lessAcName: "lessAcName",
    addAcId: "addAcId",
    addAmount: "addAmount",
    addAmountD: "addAmountD",
    lessAcId: "lessAcId",
    lessAmount: "lessAmount",
    lessAmountD: "lessAmountD",
    acPayAmount: "acPayAmount",
    billAmount: "billAmount",
    saleReturnAmount: "saleReturnAmount",
    crdrNoteAmount: "crdrNoteAmount",
    totalAmount: "totalAmount",
    adjsAcPayAmount: "adjsAcPayAmount",
    adjsBillAmount: "adjsBillAmount",
    adjsSaleReturn: "adjsSaleReturn",
    adjsCrdrNote: "adjsCrdrNote",
    adjsTotal: "adjsTotal",
    tdsAmount: "tdsAmount",
    tdsAcId: "tdsAcId",
    netRecAmount: "netRecAmount",
    rateDiff: "rateDiff",
    remarks: "remarks",
    payTo: "payTo",
    jvTrn_A: "jvTrn_A",
    jvTrn_L: "jvTrn_L",
    jvTrn_Tds: "jvTrn_Tds",
    jvTrn_no: "jvTrn_no",
    JvTrn_Rd: "JvTrn_Rd"

  };

  const ENUM_BILL_OF = {
    Sale: "Sale Bill",
    SaleReturn: "Sale Return",
    CrNote: "Credit Note",
    DrNote: "Debit Note",
    LabourIncome: "Labour Income",
    OnAcPay: "Adv.Pay",
    OnAcRec: "Adv.Rec",
  };
  const [billData, setBillData] = useState([]);

  const { isPending: isLoadingDetail, isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
    url: apiRoute.transactionEntry.fetchEntryDetail,
    queryKey: "fetchRecBillDetail",
  });


  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard.tradingDashboard)
  }, [])

  useEffect(() => {
    const params = [URIEncrypt.Payment, URIEncrypt.Receive]
    if (!params.includes(String(etype)))
      navigate(linksUrl.dashboard.tradingDashboard)

    if (etype && etype != "") {

      let t_vouType = ""
      if (etype == URIEncrypt.Receive) {
        // t_vouType = 'R'
        setEntryLabel("Receive")
      }
      if (etype == URIEncrypt.Payment) {
        //t_vouType = 'G'
        setEntryLabel("Payment")
      }
      //setSelVouType(t_vouType)
      if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
        const { transactionid, compcode, pacid, voutype } = detailParams
        funGetDetail({
          data: {
            transaction_id: transactionid,
            comp_code: compcode,
            pac_id: pacid,
            vou_type: voutype,
            isbrokarage_bill: 0
          }
        })
      }
    }
  }, [etype])
  const strField = [
    formField.partyBank,
    formField.voucherNo,
    formField.remarks,
    formField.partyName,
    formField.bookName,
    formField.lessAcName,
    formField.addAcName,
    formField.tdsAcId,
    formField.addAcId,
    formField.lessAcId,
    formField.chqAmount,
    formField.locationId,
    formField.docType
  ];

  const numberField = [
    formField.addAmount,
    formField.addAmountD,
    formField.lessAmount,
    formField.lessAmountD,
    formField.chqAmountD,
    formField.convRate,
    formField.OnAcPay,
    formField.billAmount,
    formField.saleReturnAmount,
    formField.crdrNoteAmount,
    formField.totalAmount,
    formField.netRecAmount,
    formField.adjsAcPayAmount,
    formField.adjsBillAmount,
    formField.adjsSaleReturn,
    formField.adjsCrdrNote,
    formField.adjsTotal,
    formField.tdsAmount,
    formField.rateDiff
  ]

  function calculateBillTotal({ data = [], columnName = "" }) {
    const selBill_list = data.filter((ele) => ["FULL", "PART"].includes(ele.Type)); //ele.Type != ""
    const sum = selBill_list?.reduce((accumulator, object) => {
      return Number(accumulator) + Number(object[columnName]);
    }, 0);
    return sum;
  }

  function calculateBillWiseTotal(data, columnName, billType) {
    //console.log(data)
    const selBill_list = data.filter(
      (ele) => ["FULL", "PART"].includes(ele.Type) && ele.Bill_Of == billType
    );
    // console.log(selBill_list)
    let total = selBill_list.reduce((previousValue, object) => {
      return Number(previousValue) + Number(object[columnName]);
    }, 0);
    return total;
  }

  const funGetSelBillno = (data) => {
    let selBillNo = ""
    const filterData = data.filter((ele) => ["FULL", "PART"].includes(ele.Type)); //ele.Type != "" && ele?.Type!=null
    //console.log(data, "dfg", filterData)
    if (filterData && filterData?.length > 0)
      selBillNo = filterData.map(item => item["Bill_No"]);
    return selBillNo


  }


  const funCalculateAddNAdjs = (b_data, _isAmtFromBill) => {

    let columName = "BalAmt"

    if (!isNewEntry)
      columName = "BalNPayAmt"

    const totalDrAmt = calculateBillWiseTotal(
      b_data,
      columName,
      ENUM_BILL_OF.DrNote
    );
    const totalCrAmt = calculateBillWiseTotal(
      b_data,
      !isNewEntry ? columName : "BalAmt_Mns",
      ENUM_BILL_OF.CrNote
    );
    const totalLabrIncAmt = calculateBillWiseTotal(
      b_data,
      columName,
      ENUM_BILL_OF.LabourIncome
    );
    const totalBillAmt = calculateBillWiseTotal(
      b_data,
      columName,
      ENUM_BILL_OF.Sale
    );
    const totalSaleRetAmt = calculateBillWiseTotal(
      b_data,
      !isNewEntry ? columName : "BalAmt_Mns",
      ENUM_BILL_OF.SaleReturn
    );
    const totalOnAcPay = calculateBillWiseTotal(b_data, columName, ENUM_BILL_OF.OnAcPay) + calculateBillWiseTotal(b_data, columName, ENUM_BILL_OF.OnAcRec);

    const totalAdjsBillAmt = calculateBillWiseTotal(
      b_data,
      "NewPayAmt",
      ENUM_BILL_OF.Sale
    );
    const totalAdjSaleRetAmt = calculateBillWiseTotal(
      b_data,
      "NewPayAmt",
      ENUM_BILL_OF.SaleReturn
    );
    const totalAdjCrAmt = calculateBillWiseTotal(
      b_data,
      "NewPayAmt",
      ENUM_BILL_OF.CrNote
    );
    const totalAdjDrAmt = calculateBillWiseTotal(
      b_data,
      "NewPayAmt",
      ENUM_BILL_OF.DrNote
    );
    const totalAdjLabrIncAmt = calculateBillWiseTotal(
      b_data,
      "NewPayAmt",
      ENUM_BILL_OF.LabourIncome
    );
    const totalAdjOnAcPay = calculateBillWiseTotal(b_data, "NewPayAmt", ENUM_BILL_OF.OnAcPay) + calculateBillWiseTotal(b_data, "NewPayAmt", ENUM_BILL_OF.OnAcRec);

    const totalBalAmt = calculateBillTotal({
      data: b_data,
      columnName: columName,
    });
    const totalTdsAmt = calculateBillTotal({
      data: b_data,
      columnName: "ExtTDSAmt",
    });

    let totalAmt =
      (totalOnAcPay +
        totalBillAmt +
        //totalSaleRetAmt +
        totalDrAmt +
        totalLabrIncAmt) - (totalCrAmt + totalSaleRetAmt)

    let totalAdjsAmt =
      (totalAdjOnAcPay +
        totalAdjsBillAmt +
        //totalAdjSaleRetAmt +
        totalAdjDrAmt +
        totalAdjLabrIncAmt) - (totalAdjCrAmt + totalAdjSaleRetAmt);

    let less_add_Amt = _isAmtFromBill ? totalAmt - totalAdjsAmt : parseFloat(formData.chqAmount) - totalAdjsAmt;
    let t_lessAmt =
      less_add_Amt && less_add_Amt < 0 ? Math.abs(less_add_Amt) : 0;
    let t_addAmt = less_add_Amt && less_add_Amt > 0 ? less_add_Amt : 0;
    const selBillNo = funGetSelBillno(b_data);

    return ({
      chqAmount: formData.chqAmount,
      totalBalAmt: totalBalAmt,
      totalTdsAmt: totalTdsAmt,
      totalAdjsAmt: totalAdjsAmt,
      totalAdjsBillAmt: totalAdjsBillAmt,
      totalAdjSaleRetAmt: totalAdjSaleRetAmt,
      totalAdjCrAmt: totalAdjCrAmt,
      totalAdjDrAmt: totalAdjDrAmt,
      totalAdjOnAcPay: totalAdjOnAcPay,
      totalAmt: totalAmt,
      totalLabrIncAmt: totalLabrIncAmt,
      totalBillAmt: totalBillAmt,
      totalSaleRetAmt: totalSaleRetAmt,
      totalCrAmt: totalCrAmt,
      totalDrAmt: totalDrAmt,
      totalOnAcPay: totalOnAcPay,
      t_addAmt: t_addAmt,
      t_lessAmt: t_lessAmt,
      remarks: "RECEIVED FOR INV.NO :" + selBillNo
    })
    // setFormData({
    //   ...formData,
    //   receiveAmount: totalBalAmt,
    //   tdsAmount: totalTdsAmt,
    //   adjsTotal: totalAdjsAmt,
    //   adjsBillAmount: totalAdjsBillAmt,
    //   adjsSaleReturn: totalAdjSaleRetAmt,
    //   adjsCrdrNote: totalAdjCrAmt + totalAdjDrAmt,
    //   adjsAcPayAmount: totalAdjOnAcPay,
    //   totalAmount: totalAmt,
    //   billAmount: totalLabrIncAmt + totalBillAmt,
    //   saleReturnAmount: totalSaleRetAmt,
    //   crdrNoteAmount: totalCrAmt + totalDrAmt,
    //   acPayAmount: totalOnAcPay,
    //   addAmount: t_addAmt,
    //   lessAmount: t_lessAmt,
    // });
  };

  const funSetCalcunateAddNAdjs = (cData, _isAmtFromBill) => {

    setFormData({
      ...formData,
      chqAmount: _isAmtFromBill ? cData.totalAdjsAmt : cData.chqAmount, //cData?.chqAmount==null|| cData?.chqAmount==""? cData.totalAdjsBillAmt:cData.chqAmount,
      tdsAmount: Number(cData.totalTdsAmt),
      adjsTotal: cData.totalAdjsAmt,
      adjsBillAmount: cData.totalAdjsBillAmt,
      adjsSaleReturn: cData.totalAdjSaleRetAmt,
      adjsCrdrNote: cData.totalAdjCrAmt + cData.totalAdjDrAmt,
      adjsAcPayAmount: cData.totalAdjOnAcPay,
      totalAmount: cData.totalAmt,
      billAmount: cData.totalLabrIncAmt + cData.totalBillAmt,
      saleReturnAmount: cData.totalSaleRetAmt,
      crdrNoteAmount: cData.totalCrAmt + cData.totalDrAmt,
      acPayAmount: cData.totalOnAcPay,
      addAmount: cData.t_addAmt,
      lessAmount: cData.t_lessAmt,
      remarks: cData.remarks
    });
  }
  //console.log(billData)
  const emptyFormField = Object.keys(formField).reduce((acc, key) => {
    const today = dayjs();
    if (strField.includes(key)) acc[key] = "";
    else if (key == formField.transDate || key == formField.chqRecDate)
      acc[key] = today.isAfter(dayjs(endDate))
        ? null
        : today.format("YYYY-MM-DD");
    else acc[key] = 0;
    return acc;
  }, {});

  const [formData, setFormData] = useState({
    ...emptyFormField,
  });

  const handleBillsDetail = (data) => {
    if (data && data.length > 0) {
      setBillData(data);
      const cData = funCalculateAddNAdjs(data, isAmountFromBill);
      funSetCalcunateAddNAdjs(cData, isAmountFromBill)
    } else {
      setBillData([]);
    }
  }

  useEffect(() => {
    if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
      if (
        detail &&
        !isNewEntry &&
        detail?.itemData &&
        detail?.itemData.length > 0
      ) {

        setBillData(detail?.itemDetail);
        handleBillsDetail(detail?.itemDetail);
        const cData = funCalculateAddNAdjs(detail?.itemDetail, false);
        setFormData({
          transId: detail.itemData[0]?.TransactionId ? detail.itemData[0]?.TransactionId : "",
          voucherNo: detail.itemData[0]?.Vou_No ? detail.itemData[0]?.Vou_No : "",
          transDate: detail.itemData[0]?.Chq_Date ? new Date(detail.itemData[0]?.Chq_Date).toISOString().split("T")[0] : null,
          chqRecDate: detail.itemData[0]?.Chq_Rec_Date != '' ? new Date(detail.itemData[0]?.Chq_Rec_Date).toISOString().split("T")[0] : null,
          partyName: detail.itemData[0]?.PartyName ? detail.itemData[0]?.PartyName : "",
          partyBank: detail.itemData[0]?.BankName ? detail.itemData[0]?.BankName : "",
          partyId: detail.itemData[0]?.Pac_Id ? detail.itemData[0]?.Pac_Id : 0,
          bookName: detail.itemData[0]?.BookName ? detail.itemData[0]?.BookName : 0,
          bookId: detail.itemData[0]?.Ac_Id ? detail.itemData[0]?.Ac_Id : '',
          locationId: detail.itemData[0]?.Lac_Id ? detail.itemData[0]?.Lac_Id : '',
          docType: detail.itemData[0]?.Doc_Type ? detail.itemData[0]?.Doc_Type : 0,
          chqNo: detail.itemData[0]?.Chq_No ? detail.itemData[0]?.Chq_No : 0,
          chqAmount: detail.itemData[0]?.Chq_Amt ? detail.itemData[0]?.Chq_Amt : 0,
          chqAmountD: detail.itemData[0]?.Chq_AmtD ? detail.itemData[0]?.Chq_AmtD : 0,
          jvTrn_A: detail.itemData[0]?.AJvTrnNo ? detail.itemData[0]?.AJvTrnNo : 0,
          jvTrn_L: detail.itemData[0]?.LJvTrnNo ? detail.itemData[0]?.LJvTrnNo : 0,
          jvTrn_Tds: detail.itemData[0]?.TDSJvTrnNo ? detail.itemData[0]?.TDSJvTrnNo : 0,
          jvTrn_no: detail.itemData[0]?.Trn_No ? detail.itemData[0]?.Trn_No : 0,
          JvTrn_Rd: detail.itemData[0]?.RDJvTrnNo ? detail.itemData[0]?.RDJvTrnNo : 0,
          addAcName: detail.itemData[0]?.ajv_ac_desc ? detail.itemData[0]?.ajv_ac_desc : 0,
          lessAcName: detail.itemData[0]?.ljv_ac_desc ? detail.itemData[0]?.ljv_ac_desc : 0,
          addAcId: detail.itemData[0]?.ajv_ac_id ? detail.itemData[0]?.ajv_ac_id : 0,
          lessAcId: detail.itemData[0]?.ljv_ac_id ? detail.itemData[0]?.ljv_ac_id : 0,
          addAmount: detail.itemData[0]?.AddAmt ? detail.itemData[0]?.AddAmt : 0,
          addAmountD: detail.itemData[0]?.AddAmtD ? detail.itemData[0]?.AddAmtD : 0,
          lessAmount: detail.itemData[0]?.LessAmt ? detail.itemData[0]?.LessAmt : 0,
          lessAmountD: detail.itemData[0]?.LessAmtD ? detail.itemData[0]?.LessAmtD : 0,
          tdsAmount: detail.itemData[0]?.TDSAmt ? detail.itemData[0]?.TDSAmt : 0,
          tdsAcId: detail.itemData[0]?.tjv_ac_id ? detail.itemData[0]?.tjv_ac_id : 0,
          netRecAmount: detail.itemData[0]?.Chq_Amt ? detail.itemData[0]?.Chq_Amt : 0,
          rateDiff: detail.itemData[0]?.RateDiff ? detail.itemData[0]?.RateDiff : 0,
          remarks: detail.itemData[0]?.Remark ? detail.itemData[0]?.Remark : 0,
          adjsTotal: cData?.totalAdjsAmt ? cData?.totalAdjsAmt : 0,
          adjsBillAmount: cData?.totalAdjsBillAmt ? cData?.totalAdjsBillAmt : 0,
          adjsSaleReturn: cData?.totalAdjSaleRetAmt ? cData?.totalAdjSaleRetAmt : 0,
          adjsCrdrNote: cData?.totalAdjCrAmt + cData?.totalAdjDrAmt,
          adjsAcPayAmount: cData?.totalAdjOnAcPay ? cData?.totalAdjOnAcPay : 0,
          totalAmount: cData?.totalAmt ? cData?.totalAmt : cData?.totalAmt,
          billAmount: cData?.totalLabrIncAmt + cData?.totalBillAmt,
          saleReturnAmount: cData?.totalSaleRetAmt ? cData?.totalSaleRetAmt : 0,
          crdrNoteAmount: cData?.totalCrAmt + cData?.totalDrAmt,
          acPayAmount: cData?.totalOnAcPay ? cData?.totalOnAcPay : 0,

        });
      }
    }
  }, [detail]);

  const { isLoading: isLoadingData, data: masterData = [] } = useFetchWithBody({
    url: apiRoute.transactionEntry.fetchMasterData,
    queryKey: "fetchMasterData",
    inputData: {
      comp_code: compCode.join(","),
    },
  });
  const funGetNaviLink = () => {
    //  if (selVouType == 'R')
    return linksUrl.receiveEntry.receive + "/" + URIEncrypt.Receive + linksUrl.receiveEntry.receiveEntryMaster;
    // else
    // return linksUrl.paymentEntry.payment + "/" + etype + linksUrl.paymentEntry.paymentEntryMaster;
  }
  //console.log(formData,masterData)

  const resetValues = () => {
    setFormData({ ...emptyFormField });
  };
  console.log(formData)
  const {
    isPending,
    isError,
    mutate: funInUpReceive,
  } = usePost({
    url: apiRoute.transactionEntry.add_update,
    queryKey: "InUpReceiveEntry",
    onSuccessTasks: (data) => {
      dispatch(resetDetailParams())
      if (submitBtnId == 'btnSaveNew') {
        window.location.reload();
      }
      else
        navigate(funGetNaviLink())

      submitLockRef.current = false;
    },
    resetValues,
  });

  const onSuccessBills = (data) => {
    setBillData(data);
    onOpen();

  };
  const { mutate: fnGetBills } = usePost({
    url: apiRoute.transactionEntry.getBill,
    queryKey: "getBillData",
    onSuccessTasks: onSuccessBills,
  });

  const inputBoxes = {
    Section1: {
      Row1: [
        {
          name: formField.voucherNo,
          placeholder: "Voucher No",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
        },
        {
          name: formField.transDate,
          placeholder: "Transaction Date",
          type: ENUM_INPUT_TYPE.date,
          size: "sm",
          label: "",
          isrequired: true,
        },
      ],
      Row2: [
        {
          id: formField.partyId,
          name: formField.partyId,
          placeholder: "Party Name",
          type: ENUM_INPUT_TYPE.autocomplete,
          size: "sm",
          lable: "",
          data: masterData.accountMaster,
          itemkey: "Party_Id",
          itemvalue: "Party_Name",
          isrequired: true,
        },

        {
          id: formField.bookId,
          name: formField.bookId,
          placeholder: "Book Name",
          type: ENUM_INPUT_TYPE.autocomplete,
          size: "sm",
          label: "",
          data: masterData.bookMaster,
          itemkey: "Party_Id",
          itemvalue: "Party_Name",
          isrequired: true,
        },
      ],
      Row3: [
        {
          name: formField.partyBank,
          placeholder: "Party's Bank",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          lable: "",
          isrequired: false,
        },
        {
          name: formField.chqNo,
          placeholder: "Cheque No",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
        },
      ],

      Row4: [
        {
          name: formField.docType,
          placeholder: "Doc Type",
          type: ENUM_INPUT_TYPE.select,
          size: "sm",
          label: "",
          data: masterData.docMaster,
          itemkey: "Doc_Type",
          itemvalue: "Doc_Name",
          isrequired: false,
        },
        {
          name: formField.chqRecDate,
          placeholder: "Chq.Rec.Date",
          type: ENUM_INPUT_TYPE.date,
          size: "sm",
          label: "",
          isrequired: true,
        },
      ],
      Row5: [
        {
          name: formField.chqAmount,
          placeholder: "Receive Amount",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: true,
        },
        {
          id: formField.locationId,
          name: formField.locationId,
          placeholder: "Location",
          type: ENUM_INPUT_TYPE.autocomplete,
          size: "sm",
          label: "",
          data: masterData.locationMaster,
          itemkey: "Party_Id",
          itemvalue: "Party_Name",
          isrequired: false,
        },
      ],
    },
    Section2: {
      Col1: [
        {
          id: formField.addAcId,
          name: formField.addAcId,
          placeholder: "Add  Ac",
          type: ENUM_INPUT_TYPE.autocomplete,
          size: "sm",
          label: "",
          data: masterData.accountMaster,
          itemkey: "Party_Id",
          itemvalue: "Party_Name",
          isrequired: false,
        },
        {
          name: formField.addAmount,
          placeholder: "Add  Amount",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
        },
      ],
      Col2: [
        {
          id: formField.lessAcId,
          name: formField.lessAcId,
          placeholder: "Less  Ac.",
          type: ENUM_INPUT_TYPE.autocomplete,
          size: "sm",
          label: "",
          data: masterData.accountMaster,
          itemkey: "Party_Id",
          itemvalue: "Party_Name",
          isrequired: false,
        },
        {
          name: formField.lessAmount,
          placeholder: "less  Amount",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
        },
      ],
    },

    Section3: {
      Row1: [
        {
          name: formField.acPayAmount,
          placeholder: "OnA/C. PayAmt",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
          color: "default"
        },
        {
          name: formField.adjsAcPayAmount,
          placeholder: "-",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
          color: "default"
        },
      ],
      Row2: [
        {
          name: formField.billAmount,
          placeholder: "Bill Amt",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
          color: "success"
        },
        {
          name: formField.adjsBillAmount,
          placeholder: "-",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
          color: "success"
        },
      ],
      Row3: [
        {
          name: formField.saleReturnAmount,
          placeholder: "Sale Retu",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
          color: "default"
        },
        {
          name: formField.adjsSaleReturn,
          placeholder: "-",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
          color: "default"
        },
      ],
      Row4: [
        {
          name: formField.crdrNoteAmount,
          placeholder: "CrDr Note",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
          color: "warning"
        },
        {
          name: formField.adjsCrdrNote,
          placeholder: "-",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
          color: "warning"
        },
      ],
      Row5: [
        {
          name: formField.totalAmount,
          placeholder: "Total",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
          color: "primary"
        },
        {
          name: formField.adjsTotal,
          placeholder: "-",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
          color: "primary"
        },
      ],
      Row6: [
        {
          name: formField.chqAmount,
          placeholder: "Net Rec. Amount ",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
          color: "danger"
        },
        {
          name: formField.tdsAmount,
          placeholder: "TDS Amount ",
          type: ENUM_INPUT_TYPE.text,
          size: "sm",
          label: "",
          isrequired: false,
        },

      ],
      //Row7: [
      // {
      //   name: formField.tdsAcId,
      //   placeholder: "TDS Account ",
      //   type: ENUM_INPUT_TYPE.select,
      //   size: "sm",
      //   label: "",
      //   data: masterData.tdsMaster,
      //   itemkey: "Party_Id",
      //   itemvalue: "Party_Name",
      //   isrequired: false,
      // },

      //],
    },
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    if (name == formField.chqAmount) {
      setIsAmountFromBill(false)
      if (funValidateNoInput(value)) {
        let less_add_Amt = parseFloat(value) - Number(formData.adjsTotal);
        let t_lessAmt =
          less_add_Amt && less_add_Amt < 0 ? Math.abs(less_add_Amt) : 0;
        let t_addAmt = less_add_Amt && less_add_Amt > 0 ? less_add_Amt : 0;

        setFormData({
          ...formData,
          [name]: value,
          addAmount: t_addAmt,
          lessAmount: t_lessAmt
        });
      }
    }
    else
      if (numberField.includes(name)) {
        if (funValidateNoInput(value)) {
          setFormData({
            ...formData,
            [name]: value,
          });
        }
      }
      else {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
  };
  //console.log(billData);
  const [errors, setErrors] = useState({})

  const validateForm = () => {
    const newErrors = {}


    // if (formData.docType == "") {
    //   newErrors[formField.docType] = "Doc Type No is required"
    // }

    if (formData[formField.bookId] == null || formData[formField.bookId] == "" || formData[formField.bookId] == "0") {
      newErrors[formField.bookId] = "Book Name is required"
    }

    if (formData[formField.partyId] == null || formData[formField.partyId] == "" || formData[formField.partyId] == "0") {
      newErrors[formField.partyId] = "Party Name is required"
    }

    if (formData[formField.chqAmount] == "" || formData[formField.chqAmount] == "0") {
      newErrors[formField.chqAmount] = "Receive Amount is required"
    }
    if (formData[formField.transDate] == null || formData[formField.transDate] == "" || formData[formField.chqRecDate] == "Invalid Date") {
      newErrors[formField.transDate] = "Transaction Date is required"
    }

    if (formData[formField.chqRecDate] == null || formData[formField.chqRecDate] == "" || formData[formField.chqRecDate] == "Invalid Date") {
      newErrors[formField.chqRecDate] = "Transaction Date is required"
    }
    setErrors(newErrors)

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0
  }

  useEffect(() => {
    validateForm();
  }, [formData])


  const funSubmit = () => {
    const valuesToFilter = ['FULL', 'PART'];
    let selBill_list = billData.filter(
      (ele) => valuesToFilter.includes(ele.Type) && ele.NewPayAmt !== "" && ele.NewPayAmt > 0
    );
    if (!isNewEntry) selBill_list = billData;
    funInUpReceive({
      data: {
        comp_code: compCode.join(","),
        vou_type: selVouType,
        payh_data: { ...formData, fYearSDate: dayjs(startDate).format("YYYY-MM-DD"), fYearEDate: dayjs(endDate).format("YYYY-MM-DD") },
        rec_status: !isNewEntry ? 1 : 2,
        trans_id: formData.transId,
        login_userid: user.username,
        bill_list: selBill_list,
      },
    });
  }
  const handleConfirm = () => {
    console.log("confirm")
    setOpen(false);
    funSubmit();
  };
  const handleClose = () => {
    setOpen(false);
  }
  const handleSubmit = (e) => {
    e.preventDefault();

    setSubmitBtnId(e.nativeEvent.submitter.id)
    if (submitLockRef.current) return;
    submitLockRef.current = true;
    const validate_form = validateForm()
    if (validate_form) {
      const valuesToFilter = ['FULL', 'PART'];
      let selBill_list = billData.filter(
        (ele) => valuesToFilter.includes(ele.Type) && ele.NewPayAmt !== "" && ele.NewPayAmt > 0
      );
      console.log(selBill_list, "se")
      // if (!isNewEntry) selBill_list = billData;
      if (selBill_list && selBill_list.length <= 0) {
        setOpen(true);
        submitLockRef.current = false;
        return;
      }
      else {
        funSubmit()
      }


      //}
      //else {
      // toast.error("Select Set Off Bills Details", {
      // position: "top-center"
      // })
      // }
      // }
    };
  }

  const reportModel = () => {
    return (
      <div>

      </div>
    );
  };

  const handleBtnClick = () => {
    let isPartyChange = 0;

    if (formData.partyId != "" && formData.partyId != "0") {
      if (billData && billData.length > 0) {
        onOpen();
        if (billData && billData.length > 0 && formData.partyId != "0") {
          if (billData[0].PAc_ID != formData.partyId) isPartyChange = 1;
          handleBillsDetail(billData);
          if (!isNewEntry && detail && detail.itemDetail) {
            if (detail.itemDetail[0].PAc_ID === formData.partyId) {
              handleBillsDetail(billData);
            }
          }
        }
      }


      if ((isPartyChange === 1 && billData.length > 0) || billData.length <= 0) {
        setFormData({
          ...formData,
          addAmount: 0,
          lessAmount: 0,
          tdsAmount: 0,
          adjsTotal: 0,
          adjsBillAmount: 0,
          adjsSaleReturn: 0,
          adjsCrdrNote: 0,
          adjsAcPayAmount: 0,
          totalAmount: 0,
          billAmount: 0,
          saleReturnAmount: 0,
          crdrNoteAmount: 0,
          acPayAmount: 0,
          remarks: 0
        });
        fnGetBills({
          data: {
            action: "NewData",
            comp_code: compCode.join(","),
            transaction_id: 0,
            pac_id: formData.partyId,
            vou_type: "R",
            isbrokarage_bill: 0
          },
        });
      }
    } else {
      toast.error("Select Party Name", {
        position: "top-center",
      });
    }
  };
  const handleAutoCompleteChange = (value, name) => {
    let t_Payto = formData.payTo
    if (name == formField.partyId)
      t_Payto = value;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      payTo: t_Payto
    }));
  }

  const handleClickPrev = () => {
    navigate(funGetNaviLink());
  };
  const handleDateBlur = (e, name) => {
    const input = e.target.value.trim();   // "DD/MM/YYYY"

    if (!input) return;

    // Parse typed date strictly as DD/MM/YYYY
    const parsed = dayjs(input, "DD/MM/YYYY", true);

    // ❌ Invalid format or wrong date typed
    if (!parsed.isValid()) {
      toast.error("Invalid date format. Use DD/MM/YYYY", {
        position: "top-center",
        className: "toast-error"
      });
      return;
    }

    // ❌ Out of allowed range
    if (parsed.isBefore(minAllowedDate) || parsed.isAfter(maxAllowedDate)) {
      toast.error(`Date must be between ${minAllowedDate.format("DD/MM/YYYY")} and ${maxAllowedDate.format("DD/MM/YYYY")}`, {
        position: "top-center",
        className: "toast-error"
      });
      setFormData({ ...formData, [name]: null })
      return;
    }

    // Convert to API format
    const formatted = parsed.format("YYYY-MM-DD");

    setFormData(prev => {
      const updated = { ...prev, [name]: formatted };

      // Auto-set chqRecDate if transDate was typed + blurred
      if (name === formField.transDate) {
        const chqVal = prev[formField.chqRecDate];

        if (!chqVal || chqVal === "Invalid Date") {
          updated[formField.chqRecDate] = formatted;
        }
      }

      return updated;
    });
  };
  const handleDateFinal = (newValue, name) => {
    if (name !== formField.transDate) return;

    const parsed = newValue ? dayjs(newValue, "DD/MM/YYYY") : null;
    const formatted =
      parsed && parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;

    setFormData(prev => {
      const chqValue = prev[formField.chqRecDate];

      // Only fill chqRecDate if it is empty
      if (!chqValue || chqValue === "Invalid Date") {
        return {
          ...prev,
          [formField.chqRecDate]: formatted
        };
      }

      return prev;
    });
  };
  const handleDateChange = (newValue, name) => {
    // Parse incoming date as DD/MM/YYYY strictly
    const parsed = newValue ? dayjs(newValue, "DD/MM/YYYY") : null;

    const formatted = parsed && parsed.isValid()
      ? parsed.format("YYYY-MM-DD")
      : null;

    setFormData({
      ...formData, [name]: formatted,
    })

  };

  const handleChkboxChange = (val) => {
    setIsAmountFromBill(val)
    //console.log(val)
    const cData = funCalculateAddNAdjs(billData, val);
    //console.log(cData)
    if (val) {
      setFormData({
        ...formData, [formField.chqAmount]: cData.totalAdjsAmt,
        [formField.addAmount]: cData.t_addAmt, [formField.lessAmount]: cData.t_lessAmt
      })
    }
    else
      setFormData({ ...formData, [formField.chqAmount]: "" })
    //funSetCalcunateAddNAdjs(cData)
    // if (val) {
    //   let less_add_Amt = parseFloat(formData.chqAmount) - parseFloat(formData.totalAdjsAmt);
    //   let t_lessAmt = less_add_Amt && less_add_Amt < 0 ? Math.abs(less_add_Amt) : 0;
    //   let t_addAmt = less_add_Amt && less_add_Amt > 0 ? less_add_Amt : 0;
    //   setFormData({
    //     ...formData, [formField.chqAmount]: formData[formField.adjsBillAmount],
    //     [formField.addAmount]: t_addAmt, [formField.lessAmount]: t_lessAmt
    //   })
    // }
    // else
    // setFormData({ ...formData, [formField.chqAmount]: "" })
  }
  useEffect(() => {
    scrollInput()
  }, []);

  if (isPending || isLoadingDetail) {
    return <LoadingCard />;
  }
  if (isError || isErrorDetail) {
    return <ErrorCard />;
  }

  return (
    <div>
      <MainContainer
        pageName={`${isNewEntry ? "New" : "Update"} ${entryLabel} Entry `}
        breadcrumbs={["Account", entryLabel + " Entry"]}
        prevPage={{
          show: true,
          onClick: handleClickPrev,
        }}
      >
        {reportModel()}
        <Card shadow="sm" className={stickyParentClass}>
          <form onSubmit={handleSubmit} autoComplete="off" >
            <CardBody>
              {Object.keys(inputBoxes.Section1).map((key, ind) => (
                <div key={key + ind}>
                  <div className={` ${isMobile && key == "Row2" ? 'flex-wrap' : ''}   flex gap-4 items-baseline mb-2 `}>
                    {inputBoxes.Section1[key].map((item, key) =>
                      item.type == ENUM_INPUT_TYPE.select ? (
                        <Select
                          name={item?.name}
                          placeholder="--select--"
                          label={item?.placeholder}
                          isInvalid={errors[item.name]}
                          errorMessage={errors[item.name]}
                          labelPlacement="outside"
                          selectionMode="single"
                          isVirtualized
                          isRequired={item.isrequired}
                          // value={formData[item.name]}
                          items={item.data ? item.data : []}
                          onChange={handleChange}
                          classNames={{
                            label: "text-xs text-black font-bold",
                          }}
                          selectedKeys={[String(formData[item.name])]}
                        >
                          {(list) => {
                            return (
                              <SelectItem key={list[item.itemkey]}>
                                {list[item.itemvalue]}
                              </SelectItem>
                            );
                          }}
                        </Select>
                      ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                        <Autocomplete
                          size="md"
                          name={item.name}
                          isInvalid={errors[item.name]}
                          errorMessage={errors[item.name]}
                          label={item?.placeholder}
                          eventResizeFeature={true}
                          selectionMode="single"
                          showScrollIndicators={true}
                          labelPlacement={"outside"}
                          placeholder={item.placeholder}
                          isRequired={item.isrequired}
                          isLoading={isLoadingData}
                          menuTrigger={"input"}
                          className="max-w-23"
                          classnames={{
                            label:
                              item.name == formField.partyId ||
                                item.name == formField.bookId
                                ? "font-bold "
                                : "text-xs  text-black  font-bold",
                          }}
                          variant={
                            item.name == formField.partyId ||
                              item.name == formField.bookId
                              ? "flat"
                              : "bordered"
                          }
                          color={
                            item.name == formField.partyId
                              ? "danger"
                              : item.name == formField.bookId
                                ? "success"
                                : ""
                          }
                          isClearable={false}
                          isVirtualized
                          readonly={isNewEntry ? false : true}
                          defaultItems={
                            item.data ? item.data : []
                          }
                          onSelectionChange={(e) =>
                            handleAutoCompleteChange(e, item.name)
                          }
                          selectedKey={formData[item.name]}
                        >
                          {(list) => (
                            <AutocompleteItem

                              key={list[item.itemkey]}
                            >
                              {list[item.itemvalue]}
                            </AutocompleteItem>
                          )}
                        </Autocomplete>

                      ) : item.type == ENUM_INPUT_TYPE.date ? (
                        <div className=" w-full flex items-end">
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              name={item.name}
                              label={item.placeholder}
                              views={["day", "month", "year"]}
                              format="DD/MM/YYYY"
                              minDate={minAllowedDate}
                              maxDate={maxAllowedDate}
                              value={
                                formData[item.name]
                                  ? dayjs(formData[item.name], "YYYY-MM-DD")
                                  : formData[item.name]
                              }
                              onChange={(newValue) => handleDateChange(newValue, item.name)}
                              onAccept={(newValue) => handleDateFinal(newValue, item.name)}
                              // onChange={(newValue) => {
                              //   setFormData((prev) => {
                              //     return {
                              //       ...prev,
                              //       [formField.chqRecDate]: item.name == formField.transDate &&
                              //         (formData[formField.chqRecDate] == "" || formData[formField.chqRecDate] == null) ?
                              //         dayjs(newValue).format("YYYY-MM-DD") : formData[formField.chqRecDate],
                              //       [item.name]:
                              //         dayjs(newValue).format("YYYY-MM-DD"),
                              //     };
                              //   });
                              // }}
                              className="w-full "
                              slotProps={{
                                textField: {
                                  size: "small", error: errors[item.name], helperText: errors[item.name], required: true,
                                  onBlur: (e) => handleDateBlur(e, item.name),
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </div>
                      ) : (

                        <Input
                          type={item.type}
                          name={item.name}
                          aria-label={item.placeholder}
                          placeholder={item.placeholder}
                          isInvalid={errors[item.name]}
                          errorMessage={errors[item.name]}
                          label={item.placeholder}
                          labelPlacement="outside"
                          isRequired={item.isrequired}
                          value={formData[item.name]}
                          classNames={{
                            label:
                              item.name == formField.partyCurBal ||
                                item.name == formField.bookCurBal
                                ? "font-bold "
                                : "text-xs text-black font-bold",
                          }}
                          variant={
                            item.name == formField.partyCurBal ||
                              item.name == formField.bookCurBal
                              ? "flat"
                              : "bordered"
                          }
                          isReadOnly={
                            item.name == formField.partyCurBal ||
                              item.name == formField.bookCurBal ||
                              item.name == formField.voucherNo
                              ? true
                              : false
                          }
                          color={
                            item.name == formField.partyCurBal
                              ? "warning"
                              : item.name == formField.bookCurBal
                                ? "primary"
                                : ""
                          }
                          size={"md"}
                          onChange={handleChange}
                        ></Input>
                      )
                    )}
                  </div>
                </div>
              ))}
              <div className={` flex gap-4 item-center mb-2 `}>
                <Textarea
                  type="text"
                  name={formField.remarks}
                  placeholder={"Remarks"}
                  label={"Remark"}
                  labelPlacement="outside"
                  variant="bordered"
                  classNames={{
                    label: "text-xs text-black font-bold",
                  }}
                  value={formData[formField.remarks]}
                  size={"md"}
                  onChange={handleChange}
                >

                </Textarea>
              </div>
              <div className="text-center flex  bg-red-50 items-center  justify-center gap-5 w-full py-3 my-3">
                <Checkbox size="md"
                  classNames={{ "label": "text-white text-sm" }}
                  className="py-1 px-2 font-semibold rounded-md bg-emerald-500 border-blue-200 text-rose-700 border-0"
                  color="primary"
                  isSelected={isAmountFromBill} onValueChange={(e) => handleChkboxChange(e)} >Amount From Bill Selection</Checkbox>
                <Button
                  size="sm"
                  color="warning"
                  className=" uppercase font-bold text-xs bg-orange-500 shadow-md text-white border-2 border-orange-300 
                                                  
                                              "
                  onPress={handleBtnClick}
                >

                  Show Bills Detail
                </Button>

              </div>
              <div className="align-right mb-0 bg-rose-100 p-0 text-center">
                {/* <Button
                  color="warning"
                  className=" uppercase font-bold text-xs bg-grey-50 text-sky-700 border-2 border-sky-700 border-t-sky-700
                                border-b-sky-700 border-r-rose-500 border-l-rose-500
                                rounded-sm"
                  onPress={handleBtnClick}
                >
                  Show Bills Detail
                </Button> */}
                <Drawer isOpen={isOpen} isDismissable={false} placement="top" onOpenChange={onOpenChange}>
                  <DrawerContent>
                    {(onClose) => (
                      <>
                        <DrawerHeader className="">
                          Bills Detail

                        </DrawerHeader>

                        <DrawerBody>
                          <div
                            className="p-2  border-2 border-b-rose-400  uppercase text-sky-700 font-bold text-sm">
                            Bills Detail
                          </div>
                          <BillsDetail
                            handleBillsDetail={handleBillsDetail}
                            billData={billData}
                            entryType={ENUM_TRANSACTION_TYPE.PAYMENT}
                          />

                        </DrawerBody>
                        <DrawerFooter className="flex justify-between">
                          {billData && billData.length <= 100 ? (
                            <h6 className="text-sm text-pink-500">
                              Total Bills :{billData ? billData.length : 0}
                            </h6>
                          ) : (
                            ""
                          )}
                          <Button color="danger" size="sm" variant="bordered" onPress={onClose}>
                            Close
                          </Button>
                        </DrawerFooter>
                      </>
                    )}
                  </DrawerContent>
                </Drawer>
              </div>
              <div className="flex sm:flex-wrap md:flex-nowrap gap-2 items-baseline mb-2 ">
                {Object.keys(inputBoxes.Section2).map((key, ind) => (
                  <div className="w-full">
                    <div>
                      <span className="section_head">
                        {" "}
                        <FontAwesomeIcon
                          className="section_arow"
                          icon={faArrowRightLong}
                        ></FontAwesomeIcon>
                        {key == "Col1" ? "Add Amount" : "Less Amount"}
                      </span>
                    </div>
                    <div className=" gap-2  item-center py-3  border-0 border-stone-300 w-full">
                      {inputBoxes.Section2[key].map((item, key) =>
                        item.type == ENUM_INPUT_TYPE.autocomplete ? (
                          <Autocomplete
                            size="md"
                            name={item.name}
                            isInvalid={errors[item.name]}
                            errorMessage={errors[item.name]}
                            label={item?.placeholder}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            labelPlacement={"outside"}
                            variant="flat"
                            color="warning"
                            menuTrigger={"input"}
                            placeholder={item.placeholder}
                            isRequired={item.isrequired}
                            isLoading={isLoadingData}
                            className="max-w-23"
                            classNames={{
                              label: "text-xs text-black font-bold",
                            }}
                            isClearable={false}
                            isVirtualized
                            readonly={isNewEntry ? false : true}
                            defaultItems={
                              item.data ? item.data : []
                            }
                            onSelectionChange={(e) =>
                              handleAutoCompleteChange(e, item.name)
                            }
                            selectedKey={formData[item.name]}
                          >
                            {(list) => (
                              <AutocompleteItem
                                key={list[item.itemkey]}
                              >
                                {list[item.itemvalue]}
                              </AutocompleteItem>
                            )}
                          </Autocomplete>
                        ) : (
                          <Input
                            type={item.type}
                            name={item.name}
                            aria-label={item.placeholder}
                            placeholder={item.placeholder}
                            label={item.placeholder}
                            labelPlacement="outside"
                            isRequired={item.isrequired}
                            value={formData[item.name]}
                            classNames={{ label: "text-xs mt-1 font-bold" }}
                            variant="bordered"
                            size={"md"}
                            onChange={handleChange}
                          ></Input>
                        )
                      )}
                    </div>
                  </div>
                ))}
              </div>
              {Object.keys(inputBoxes.Section3).map((key, ind) => (
                <div key={key + ind}>
                  {key == "Row1" ? (
                    <div className="flex gap-2 justify-between mb-3">
                      <div className="w-full">
                        <span className="section_head">
                          {" "}
                          <FontAwesomeIcon
                            className="section_arow"
                            icon={faArrowRightLong}
                          ></FontAwesomeIcon>
                          ADD
                        </span>
                      </div>
                      <div className="w-full">
                        <span className="section_head w-full">
                          {" "}
                          <FontAwesomeIcon
                            className="section_arow"
                            icon={faArrowRightLong}
                          ></FontAwesomeIcon>
                          Adjusted
                        </span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="flex gap-4 item-center mb-2">
                    {inputBoxes.Section3[key].map((item, key) => item.type == ENUM_INPUT_TYPE.select ? (
                      <Select
                        name={item?.name}
                        placeholder="--select--"
                        label={item?.placeholder}
                        labelPlacement="outside"
                        selectionMode="single"
                        isRequired={item.isrequired}
                        isVirtualized
                        items={item.data ? item.data : []}
                        onChange={handleChange}
                        classNames={{
                          label: "text-xs text-black font-bold",
                        }}
                        selectedKeys={[String(formData[item.name])]}
                      >
                        {(list) => {
                          return (
                            <SelectItem key={list[item.itemkey]}>
                              {list[item.itemvalue]}
                            </SelectItem>
                          );
                        }}
                      </Select>
                    ) : (
                      <Input
                        type={item.type}
                        name={item.name}
                        aria-label={item.placeholder}
                        placeholder={item.placeholder}
                        label={item.placeholder}
                        labelPlacement="outside"
                        isRequired={item.isrequired}
                        value={formData[item.name]}
                        classNames={{ label: "text-xs font-bold" }}
                        variant="flat"
                        readOnly={true}
                        size={"md"}
                        color={item.color}
                        onChange={handleChange}
                      ></Input>
                    ))}
                  </div>
                </div>
              ))}
            </CardBody>
            <div className={stickyBottomClass}>
              <div className="justify-center flex items-center gap-4">
                <Button
                  color="primary"
                  type="submit"
                  size="sm"
                  id="btnSave"
                  variant="shadow"
                  className="uppercase font-semibold"
                  startContent={<FontAwesomeIcon icon={faSave} />}
                >
                  Submit
                </Button>
                <Button
                  id="btnSaveNew"
                  color="success"
                  type="submit"
                  size="sm"
                  variant="shadow"
                  className="text-white uppercase font-semibold"
                  startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                >
                  Save & New
                </Button>
                <Button
                  color="danger"
                  variant="shadow"
                  size="sm"
                  onPress={handleClickPrev}
                  className="uppercase font-semibold"
                  startContent={<FontAwesomeIcon icon={faCancel} />}
                >
                  Cancel
                </Button>
              </div>
            </div>

          </form>
          <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="xs"
            PaperProps={{
              sx: {
                width: "360px",
                maxWidth: "90vw",
                borderRadius: 2,
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                py: 1.5,
                px: 2,
              }}
            >
              <FontAwesomeIcon
                icon={faWarning}
                className="text-yellow-500"
              />


              <Typography
                fontWeight="bold"
                className="text-yellow-500 text-sm p-0 m-0"
              >
                Confirmation
              </Typography>


            </DialogTitle>

            <DialogContent sx={{ px: 2, py: 1 }}>
              <DialogContentText
                sx={{
                  color: "text.primary",
                  fontSize: 14,
                  lineHeight: 1.5,
                }}
              > <b>No Set-Off Bills Detail have been selected.</b> </DialogContentText>


              <Typography
                sx={{
                  mt: 1,
                  fontSize: 13,
                  fontWeight: 500,
                }}
                className="text-red-500"
              >
                Do you want to continue without selecting any bills?
              </Typography>


            </DialogContent>

            <DialogActions
              sx={{
                px: 2,
                py: 1.5,
                gap: 1,
              }}

            >


              <Button

                onPress={handleClose}
                variant="flat"
                color="danger"
                size="sm"
                className="font-semibold text-sm"
                startContent={
                  <FontAwesomeIcon icon={faXmark} />
                }
              >
                NO
              </Button>

              <Button
                onPress={handleConfirm}
                variant="flat"
                color="success"
                autoFocus
                size="sm"
                className="font-semibold text-sm"
                startContent={
                  <FontAwesomeIcon icon={faCheck} />
                }
              >
                YES
              </Button>
            </DialogActions>
          </Dialog>

        </Card>
      </MainContainer>
    </div>
  );
};
export default CreateTransactionEntry;
